import { render } from "./App.vue?vue&type=template&id=64262e23"
const script = {}

import "./App.vue?vue&type=style&index=0&id=64262e23&lang=css"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__